import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" data-name="Warstwa 1" viewBox="7 7 46 46" {...props}><path fill="#345d9d" d="M51.94 35.47A22.61 22.61 0 1135.47 8.06a22.6 22.6 0 0116.47 27.41z" /><path fill="#fff" d="M29.37 37.08l1.45-5.42 3.41-1.25.84-3.18v-.08l-3.36 1.22 2.42-9.11h-6.88l-3.17 11.89-2.64 1-.87 3.28 2.64-1-1.87 7H39.6l1.17-4.36h-11.4" /></svg>;